import React from 'react';
import Modal from '@omilia/modal';
import { Form, Field } from 'react-final-form';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

import TextFieldFinalFormWrapper from 'components/TextFieldFinalFormWrapper';
import validate from './utils';
import { Props } from './types';

const SForm = styled.form`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CreateNewRuleModal = ({ initialValue, onSubmit, onClose }: Props) => (
  <Modal
    open
    shouldCloseOnBackdropClick
    shouldCloseOnEscPress
    glyph="context-rules"
    title="Create Context Rule"
    onClose={onClose}
  >
    <Form onSubmit={onSubmit}>
      {({ handleSubmit, invalid, submitting }) => (
        <SForm onSubmit={handleSubmit}>
          <Field
            component={TextFieldFinalFormWrapper}
            data-test="context-rule-name-input"
            initialValue={initialValue}
            label="CONTEXT RULE NAME"
            name="ruleName"
            placeholder="Please type a name for the context rule"
            validate={validate}
          />
          <ButtonGroup>
            <Button
              color="secondary"
              data-test="cancel-button"
              variant="text"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              data-test="create-button"
              disabled={invalid}
              loading={submitting}
              type="submit"
              variant="contained"
            >
              Create
            </Button>
          </ButtonGroup>
        </SForm>
      )}
    </Form>
  </Modal>
);

export default CreateNewRuleModal;
